import { apiClient, routes } from 'common/services';
import type { OrganizationDetailDataObject } from 'models/service';

export const getOrganizationDetail = async ({ organizationId }: { organizationId: string }) =>
  apiClient.get<OrganizationDetailDataObject>(routes.organizations.detail(organizationId));
